<template>

  <div class="card card-user">
    <div class="card-body">
      <form>
        <div class="form-group row">
          <label class="col-md-2 col-form-label">System Name</label>
          <div class="col-md-10">
            <input v-model="player.name" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2 col-form-label">Display Name</label>
          <div class="col-md-10">
            <input v-model="player.displayName" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2 col-form-label">加權</label>
          <div class="col-md-10">
            <input v-model="player.weighted" type="text" class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="update ml-auto mr-auto">
            <button type="submit" class="btn btn-primary btn-round" @click="submit">送出</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerUpdate',
  data: function() {
    return {
      id: this.$route.params.id,
      teams: [],
      player: {
        teamId: '',
        name: '',
        displayName: '',
        weighted: ''
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData: function() {
      this.$store.commit('OPEN_LOADING')

      this.$store.dispatch('getList', { type: 'Team', action: 'list' }).then((res) => {
        if (!res.errorCode) {
          this.teams = res.data
          this.$store.dispatch('getData', { type: 'Player', credentials: this.id }).then((res) => {
            if (!res.errorCode) {
              this.player = res.data
              this.$store.commit('CLOSE_LOADING')
            }
          })
        }
      })
    },

    submit: function() {
      this.$store.commit('OPEN_LOADING')

      var data = {
        id: this.id,
        player: this.player
      }
      this.$store.dispatch('playerUpdate', { credentials: data }).then((res) => {
        if (!res.errorCode) {
          this.$store.commit('CLOSE_LOADING')

          this.$router.push({ name: 'Player.List' })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
